import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '@/auth/AuthContext';
import { hasPermission } from '@/types';

export interface AdminTab {
  /** Ścieżka względna do trasy nadrzędnej (np. '' dla index, 'firmy'). */
  to: string;
  label: string;
  /** Dokładne dopasowanie (dla zakładki index, to=''). */
  end?: boolean;
  /**
   * Uprawnienie wymagane przez API tej podstrony. Grupy administracji są bramkowane jednym
   * uprawnieniem na całą trasę, ale poszczególne zakładki wołają API pod INNYMI uprawnieniami
   * (np. Macierz uprawnień → ADMIN_PERMISSIONS, Zużycie tokenów → AI_VIEW_COSTS). Bez tego
   * zakładka była widoczna i zwracała same 403.
   */
  requirePerm?: string;
}

/**
 * Wspólna powłoka zagregowanych ekranów administracji: „eyebrow" z nazwą grupy + pasek
 * zakładek (NavLink względem trasy nadrzędnej), a poniżej <Outlet/> z konkretną podstroną.
 * Podstrony zachowują własne nagłówki i URL-e (deep-link + własne search-paramy).
 */
export function AdminTabsLayout({ group, tabs }: { group: string; tabs: AdminTab[] }) {
  const { user } = useAuth();
  const widoczne = tabs.filter(t => !t.requirePerm || hasPermission(user, t.requirePerm));
  return (
    <div className="max-w-[1400px]">
      <div className="text-[11px] uppercase tracking-wide text-ink-400 font-semibold mb-1.5">
        Administracja · {group}
      </div>
      <div className="flex gap-1 border-b border-ink-200 mb-4 overflow-x-auto">
        {widoczne.map(t => (
          <NavLink key={t.to || 'index'} to={t.to} end={t.end}
            className={({ isActive }) =>
              'px-3 py-2 text-[13px] font-medium whitespace-nowrap border-b-2 -mb-px transition ' +
              (isActive
                ? 'border-water-500 text-water-700'
                : 'border-transparent text-ink-500 hover:text-ink-800 hover:border-ink-200')}>
            {t.label}
          </NavLink>
        ))}
      </div>
      <Outlet />
    </div>
  );
}
